import React, { useState } from "react";
import useBackdropClose from "../../hooks/useBackdropClose";
import { useTranslation } from "react-i18next";
import {
  Overlay, Modal, ModalTitle, Body,
  CheckRow, Checkbox, CheckLabel,
  ActionRow, CancelButton, DeleteButton,
} from "./styles";

const DeletePatientModal = ({ patientCode, loading, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const [acknowledged, setAcknowledged] = useState(false);

  return (
    <Overlay {...useBackdropClose(onCancel)}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <ModalTitle>{t("deletePatient.title")}</ModalTitle>

        <Body>{t("deletePatient.body", { code: patientCode })}</Body>

        <CheckRow>
          <Checkbox
            type="checkbox"
            id="delete-ack"
            checked={acknowledged}
            onChange={(e) => setAcknowledged(e.target.checked)}
          />
          <CheckLabel htmlFor="delete-ack">{t("deletePatient.ack")}</CheckLabel>
        </CheckRow>

        <ActionRow>
          <CancelButton onClick={onCancel}>{t("deletePatient.cancel")}</CancelButton>
          <DeleteButton disabled={!acknowledged || loading} onClick={onConfirm}>
            {loading ? t("deletePatient.deleting") : t("deletePatient.confirm")}
          </DeleteButton>
        </ActionRow>
      </Modal>
    </Overlay>
  );
};

export default DeletePatientModal;
